import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, toIconName } from '@lichtblick/icons';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { CheckCircleS } from '@lichtblick/photon/icons/symbols/check-circle-s';
import utilityStyles from '@lichtblick/photon/theme/utilities.module.scss';
import classNames from 'classnames';
import { RichText } from '../../helpers/RichText';
import styles from './a-list-item.module.css';
const iconColorMap = {
    red: 'light-red',
    green: 'light-moss',
    black: 'black'
};
const getElementMappers = (textSizeOverride)=>({
        p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
                renderAs: "p",
                size: textSizeOverride,
                children: children
            })
    });
export const AListItem = ({ className, color, colorOverride, icon, isBold, richText, textSizeOverride = 'm', title, value })=>{
    const content = richText && /*#__PURE__*/ _jsx(RichText, {
        elementMappers: getElementMappers(textSizeOverride),
        richText: richText
    });
    if (!content) {
        return null;
    }
    return title && value ? /*#__PURE__*/ _jsxs("li", {
        className: styles['paired-item'],
        children: [
            /*#__PURE__*/ _jsx(Text, {
                bold: isBold,
                children: title
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles['paired-item-dotted-line']
            }),
            /*#__PURE__*/ _jsx(Text, {
                bold: isBold,
                children: value
            })
        ]
    }, value) : /*#__PURE__*/ _jsxs(LiItem, {
        className: className,
        children: [
            icon && /*#__PURE__*/ _jsx(Icon, {
                className: classNames(styles.icon, textSizeOverride === 's' && styles['icon-small-margin-top'], utilityStyles[`theme-color-${colorOverride || iconColorMap[color || 'green']}`]),
                name: toIconName(icon)
            }),
            /*#__PURE__*/ _jsx(Text, {
                size: textSizeOverride,
                children: content
            })
        ]
    });
};
export const LiItem = ({ children, className })=>/*#__PURE__*/ _jsx("li", {
        className: classNames(styles.item, className),
        children: children
    });
export const ListCheckCircleIcon = ({ color })=>/*#__PURE__*/ _jsx(CheckCircleS, {
        className: classNames(styles.icon, styles['small-margin-top'], color && utilityStyles[`theme-color-${color}`])
    });

//# sourceMappingURL=AListItem.js.map